import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {FUIAlertAction, FUIAlertActions, FUIAlertService, FUISpinnersService} from "@fedelta-pos/ui";
import {DisputeService} from "../dispute.service";
import {ErrorHandlerService} from "../../../error-handler.service";
import {DisputeModel} from "../dispute.model";
import {ActivatedRoute} from "@angular/router";
import {CustomerPortalService} from "../../customer-portal/customer-portal.service";
import {EvidenceFile} from "../dispute-evidence-submit-request.data";

@Component({
    selector: "fhm-dispute-evidence-submit-page",
    styleUrls: ["dispute-evidence-submit-page.component.scss"],
    templateUrl: "./dispute-evidence-submit-page.component.html",
    providers: [DisputeService, DisputeModel, CustomerPortalService],
    standalone: false
})
export class DisputeEvidenceSubmitPageComponent implements OnInit {

    private readonly MAX_UPLOAD_CONTRACT_SIZE = 10485760;

    @ViewChild("inputUploadFile", {read: ElementRef}) public inputUploadFile: ElementRef;

    evidenceSubmitted: boolean;
    submitAttempted: boolean;

    constructor(private spinnersService: FUISpinnersService,
                private disputeService: DisputeService,
                private errorHandler: ErrorHandlerService,
                public model: DisputeModel,
                private alertService: FUIAlertService,
                private route: ActivatedRoute,
                private customerPortalService: CustomerPortalService) {
    }

    ngOnInit(): void {
        this.init();
    }

    async init(): Promise<void> {
        this.model.disputeId = this.customerPortalService.getUrlParameter("disputeId");
        await this.model.loadDispute();
//        this.evidenceSubmitted = this.model.dispute.evidenceSubmitted;
    }

    uploadMenu(): void {
        this.inputUploadFile.nativeElement.click();
    }

    async uploadEvidenceFile(file): Promise<void> {
        this.spinnersService.open();
        try {
            const response: any = await this.disputeService.uploadEvidence(this.model.disputeId, file);

            this.model.addEvidenceFile(response.fileId, undefined, file.name);

            this.spinnersService.close();
        } catch (e) {
            this.spinnersService.close();
            this.errorHandler.handleErrorResponse(e);
        }
    }

    inputUploadContractClick(event: MouseEvent): void {
        event.stopPropagation();
    }

    fileSelected(event: Event): void {
        const fileList: FileList = (<HTMLInputElement>event.target).files;
        if (fileList && fileList.length > 0) {
            try {
                const file: File = fileList[0];
                if (file.size > this.MAX_UPLOAD_CONTRACT_SIZE) {
                    this.alertService.showError("fhm.contract.alert.uploadContractSizeLimit.title",
                        "fhm.contract.alert.uploadContractSizeLimit.message").subscribe(() => {
                    });
                    return;
                }
                this.uploadEvidenceFile(file);
            } finally {
                (<HTMLInputElement>event.target).value = null;
            }
        }
    }

    deleteEvidenceFile(evidenceFile: EvidenceFile): void {
        this.model.disputeEvidenceRequest.evidenceFiles =
            this.model.disputeEvidenceRequest.evidenceFiles.filter(value => value.fileId !== evidenceFile.fileId);
    }

    async submitEvidence(): Promise<void> {
        if (!this.validateEvidence()) {
            return;
        }
        const action: FUIAlertAction = await this.alertService.showWarningOkCancel("fhm.dispute.prompt.submit.title",
            "fhm.dispute.prompt.submit.message").toPromise();
        if (action === FUIAlertActions.OK_ACTION) {
            this.spinnersService.open();
            try {
                await this.model.submitEvidence();
                this.evidenceSubmitted = true;
                this.spinnersService.close();
            } catch (e) {
                this.spinnersService.close();
                this.errorHandler.handleErrorResponse(e);
            }
        }
    }

    validateEvidence(): boolean {
        this.submitAttempted = true;
        if (this.model.disputeEvidenceRequest.evidenceFiles.length === 0 && !this.model.disputeEvidenceRequest.additionalInformation) {
            this.alertService.showError("fhm.dispute.prompt.emptyForm.title",
                "fhm.dispute.prompt.emptyForm.message").subscribe(() => {
            });
            return false;
        }
        if (this.model.disputeEvidenceRequest.evidenceFiles.find(value => !value.evidenceType) !== undefined) {
            return false;
        }
        const evidenceTypes: string[] = this.model.disputeEvidenceRequest.evidenceFiles.map(value => value.evidenceType);
        if ([...new Set(evidenceTypes)].length !== evidenceTypes.length) {
            this.alertService.showError("fhm.dispute.prompt.evidenceCategoryUnique.title",
                "fhm.dispute.prompt.evidenceCategoryUnique.message").subscribe(() => {
            });
            return false;
        }
        return true;
    }
}
